"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useConnectivityStatus;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useConnectivityStatus() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var connectivityStatus = _ref.connectivityStatus;
    return connectivityStatus;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VDb25uZWN0aXZpdHlTdGF0dXMiLCJ1c2VTZWxlY3RvciIsImNvbm5lY3Rpdml0eVN0YXR1cyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZUNvbm5lY3Rpdml0eVN0YXR1cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUNvbm5lY3Rpdml0eVN0YXR1cygpOiBbc3RyaW5nXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgY29ubmVjdGl2aXR5U3RhdHVzIH0pID0+IGNvbm5lY3Rpdml0eVN0YXR1cyldO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EscUJBQVQsR0FBMkM7RUFDeEQsT0FBTyxDQUFDLElBQUFDLGdDQUFBLEVBQVk7SUFBQSxJQUFHQyxrQkFBSCxRQUFHQSxrQkFBSDtJQUFBLE9BQTRCQSxrQkFBNUI7RUFBQSxDQUFaLENBQUQsQ0FBUDtBQUNEIn0=